import * as React from "react";
import { getPersistedZipCode, setPersistedZipCode } from "../user-settings";
import Loader from "src/js/components/Loader/LoadingSpinner";

type LocationSelectedProps = {
  onLocationSelected: (zip: string) => void;
};

export const ZipCodeSelector: React.FC<LocationSelectedProps> = ({
  onLocationSelected,
}) => {
  const [zip, setZip] = React.useState("");

  const [submitting, setSubmitting] = React.useState(false);

  React.useEffect(() => {
    async function loadZip() {
      const persistedZip = await getPersistedZipCode();
      setZip(persistedZip);
    }
    loadZip();
  }, []);

  const handleZip = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setZip(value);
  };

  const handleSubmit = async (event?: React.MouseEvent) => {
    if (submitting) {
      return;
    }

    if (event) {
      event.preventDefault();
    }
    setSubmitting(true);

    await setPersistedZipCode(zip);
    onLocationSelected(zip);
  };

  const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code && e.code.endsWith("Enter")) {
      e.preventDefault();
      const target = e.target as HTMLInputElement; //.target.value;
      const value = target.value;

      if (value !== "" && value.length >= 5) {
        handleSubmit();
      }

      return false;
    }
    return true;
  };

  return (
    <>
      <div className="form-group">
        <label>Delivery Zip Code:</label>
        <input
          name="ZipCode"
          className="form-control"
          value={zip}
          onChange={handleZip}
          onKeyDown={handleEnter}
        />
      </div>
      <div className="button-row">
        {submitting && (
          <div className="hgs-button submitting">
            <Loader message="Saving Changes"></Loader>
          </div>
        )}
        {!submitting && (
          <div className="hgs-button" onClick={handleSubmit}>
            Check Availability
          </div>
        )}
      </div>
    </>
  );
};
